import { StickyNoteProperties } from "../model/viewModel/stickyNoteProperties";
import { RichText } from "../model/viewModel/richText";

export const getStickyNoteProperties = (richTexts: RichText[]) => {
  const stickyNoteProperties: StickyNoteProperties = new StickyNoteProperties(richTexts);
  return stickyNoteProperties;
};
